import React, { useState } from 'react';
import CommunityAdminHeaders from './CommunityAdminHeaders';
import CommunityAdminForums from './CommunityAdminForums';
import CommunityAdminChats from './CommunityAdminChats';

type AdminTab = 'headers' | 'forums' | 'chats';

const TABS: { id: AdminTab; label: string }[] = [
  { id: 'headers', label: 'Заголовки' },
  { id: 'forums', label: 'Форумы' },
  { id: 'chats', label: 'Чаты' },
];

export default function CommunityAdminPanel({ onBack }: { onBack: () => void; realIsAdmin?: boolean }) {
  const [tab, setTab] = useState<AdminTab>('headers');

  return (
    <div>
      <button type="button" className="dcf-btn dcf-btn--ghost mb-4" onClick={onBack}>
        ← К сообществу
      </button>

      <header className="dcf-header">
        <h1 className="dcf-header__title">Навигация сообщества</h1>
        <p className="dcf-header__desc">
          Заголовки группируют пункты в левой панели. Под каждым заголовком — форумы (темы и ответы) и текстовые чаты.
        </p>
      </header>

      <div className="dcf-admin-tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className={`dcf-admin-tabs__btn ${tab === t.id ? 'dcf-admin-tabs__btn--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'headers' && <CommunityAdminHeaders />}
      {tab === 'forums' && <CommunityAdminForums />}
      {tab === 'chats' && <CommunityAdminChats />}
    </div>
  );
}
